<template>
  <v-dialog
    v-model="computedDialogUiLegal"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card>
        <v-btn icon @click.native="methodDialogUi('legal')">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>About</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-list three-line subheader>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>Copyright Notice</v-list-tile-title>
              <v-list-tile-sub-title>
                <b>App, website, back-end infrastructure:</b>
                {{ computedGeneral.copyright.app }}
              </v-list-tile-sub-title>
              <v-list-tile-sub-title>
                <b>Data:</b>
                {{ computedGeneral.copyright.data }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title
                >About {{ computedGeneral.title }}</v-list-tile-title
              >
              <v-list-tile-sub-title>
                {{ computedGeneral.title }} was proudly created in Whistler by
                Mike Hamilton.
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>Build #</v-list-tile-title>
              <v-list-tile-sub-title>{{
                build_timestamp
              }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card-text>

      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      build_timestamp: process.env.VUE_APP_BUILD_NUM
    };
  },
  computed: {
    computedDialogUiLegal() {
      return this.$store.state.ui.dialogs.legal;
    },
    computedGeneral() {
      return this.$store.state.general;
    }
  },
  methods: {
    methodDialogUi(dialog) {
      this.$store.commit("mutationDialogUi", {
        dialog: dialog
      });
    }
  }
};
</script>
